module.exports = __webpack_public_path__ + "static/media/modalImg6.67459f07.png";